import { Alignment, HeaderLevel } from '../../types/AgilityTypes';

/**
 * Maps a training fields object to the props expected by SpecificTrainingMain.
 */
export const mapTrainingFieldsToProps = (fields: any) => {
  return {
    backgroundStyle: { color: fields.backgroundStyle?.fields?.color },
    title: fields.title,
    titleStyle: {
      level: fields.titleStyle?.fields?.level as HeaderLevel,
      color: fields.titleStyle?.fields?.color,
    },
    subTitle: fields.subTitle,
    subTitleStyle: {
      color: fields.subTitleStyle?.fields?.textColor,
      textColor: fields.subTitleStyle?.fields?.textColor,
      fontSize: fields.subTitleStyle?.fields?.textSize,
      alignment: fields.subTitleStyle?.fields.alignment as Alignment,
      textAlignment: fields.subTitleStyle?.fields.alignment as Alignment,
    },
    numberOfDays: fields.numberOfDays,
    numberOfDaysStyle: {
      color: fields.numberOfDaysStyle?.fields.textColor,
      textColor: fields.numberOfDaysStyle?.fields.textColor,
      fontSize: fields.numberOfDaysStyle?.fields.textSize,
      alignment: fields.numberOfDaysStyle?.fields.alignment as Alignment,
      textAlignment: fields.numberOfDaysStyle?.fields.alignment as Alignment,
    },
    includedButtonLabel: fields.buttonLabel,
    includedButtonStyle: {
      name: fields.includedButtonStyle?.fields?.name,
      color: fields.includedButtonStyle?.fields?.color,
      variant: fields.includedButtonStyle?.fields?.variant,
      textColor: fields.includedButtonStyle?.fields?.textColor,
    },
    contentTitle: fields.contentTitle,
    contentTitleStyle: {
      level: fields.contentTitleStyle?.fields?.level as HeaderLevel,
      color: fields.contentTitleStyle?.fields?.color,
    },
    options: Array.isArray(fields.options)
      ? fields.options.map((opt: any) => ({
          text: opt?.fields?.text || opt?.fields?.iconImage?.label || '',
          iconImage: opt?.fields?.iconImage || {
            label: '',
            url: '',
            target: null,
            filesize: null,
            pixelHeight: null,
            pixelWidth: null,
          },
          sortOrder: opt.fields?.sortOrder || '',
          textStyle: opt.fields?.textStyle,
        }))
      : [],
    expandOnLanding: fields.expandOnLanding,
    iconColor: { color: fields.iconColor?.fields.color },
    shortTextColor: { color: fields.shortTextColor?.fields.color },
    desktopAlignment: fields.desktopAlignment as Alignment,
    mobileAlignment: fields.mobileAlignment as Alignment,
    contactUsButton: fields.contactUsButton,
    contactUsButtonStyle: {
      name: fields.contactUsButtonStyle?.fields?.name,
      color: fields.contactUsButtonStyle?.fields?.color,
      variant: fields.contactUsButtonStyle?.fields?.variant,
      textColor: fields.contactUsButtonStyle?.fields?.textColor,
    },
    contentBackgroundColor: {
      color: fields.contentBackgroundColor?.fields.color,
    },
  };
};
